import { render, staticRenderFns } from "./CalculateDataTable.vue?vue&type=template&id=6d91d087&"
import script from "./CalculateDataTable.vue?vue&type=script&lang=js&"
export * from "./CalculateDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VPagination } from 'vuetify/lib/components/VPagination';
installComponents(component, {VDataTable,VPagination})


/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6d91d087')) {
      api.createRecord('6d91d087', component.options)
    } else {
      api.reload('6d91d087', component.options)
    }
    module.hot.accept("./CalculateDataTable.vue?vue&type=template&id=6d91d087&", function () {
      api.rerender('6d91d087', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/Shipping/components/ShippingCalculate/CalculateDataTable.vue"
export default component.exports